/// <reference path="../../public/jquery-1.6.2.min.js" />
/// <reference path="../../public/General.js" />
/// <reference path="../../SumoDataAccess.js" />
/// <reference path="../../SumoClass.js" />
/// <reference path="../ControlBase.js" />

if (isNullOrUndefined(sumo)) {
    throw ('ListView.js requies the sumo namespace defined in SumoClass.js');
}

if (isNullOrUndefined(sumo.controls)) {
    throw ('ListView.js requies the sumo.controls namespace defined in ControlBase.js');
}

// options
//  keyField
//  keyFieldType: string, number
//  selectMethod: single, auto, ctrlKey, none
//  cssClass
//  canUnselect
//  oddRowClass
//  evenRowClass
//  showHeader: default = true

// column definitions
//  id
//  title
//  hoverText
//  dataField - mutually exclusvie with html
//  width: px, autoData, autoHeader
//  minWidth
//  maxWidth
//  sortable
//  cssClass
//  formatMethod
//  canResize
//  html - mutually exclusive with dataField - useful for putting raw html into a column for icons, images, etc.

sumo.controls.ListView = function (aId, aParentId, aOptions, aColumns) {
    "use strict";

    sumo.controls.ListView.prototype.baseClass.call(this, aId, aParentId,
        '<div class="sumo-listview-control" id="##id##" style="height: 100%; overflow: hidden;"></div>',
        aOptions);

    var mThis = this,
        mSelectedKey = null,
        mViewIndex = [],
        mDataIndex = {},
        mDataSource = null,
        mIsDirty = false,
        mIsSorted = false,
        mColumns = aColumns,
        deselectedKey,
        selectedKey,

    // options
        mKeyField = null,
        mKeyFieldType = 'string',
        mSelectMethod = 'single',
        mCssClass = null,
        mCanUnselect = false,
        mScrollIntoView = true,
    //mAlternateShadingEnabled = false,
        mOddRowClass = null,
        mEvenRowClass = null,
        mShowHeader = true,

    // html/jquery elements
        mViewPort = null,
        mHeader = null,
        mTable = null,
        mRows = null,
        mBody = null,
        mUpdatedRow = null,
        mUpdateNotice = null,
        mSortableColumn = null,
        mSortedColumn = {},
        mLocalization = false,
        mSortArrow = null;

    if (!this.isNothing(aOptions)) {
        if (!this.isNothing(aOptions.keyField)) {
            mKeyField = aOptions.keyField;
        }
        if (!this.isNothing(aOptions.keyFieldType)) {
            mKeyFieldType = aOptions.keyFieldType;
        }
        if (!this.isNothing(aOptions.selectMethod)) {
            mSelectMethod = aOptions.selectMethod;
        }
        if (!this.isNothing(aOptions.cssClass)) {
            mCssClass = aOptions.cssClass;
        }
        if (!this.isNothing(aOptions.canUnselect)) {
            mCanUnselect = aOptions.canUnselect;
        }
        if (!this.isNothing(aOptions.oddRowClass)) {
            mOddRowClass = aOptions.oddRowClass;
        }
        if (!this.isNothing(aOptions.evenRowClass)) {
            mEvenRowClass = aOptions.evenRowClass;
        }
        if (!this.isNothing(aOptions.showHeader)) {
            mShowHeader = aOptions.showHeader;
        }
        if (!this.isNothing(aOptions.scrollIntoView)) {
            mScrollIntoView = aOptions.scrollIntoView;
        }
        if (!this.isNothing(aOptions.localization)) {
            mLocalization = aOptions.localization;
        }
    }


    function getHeaderContent() {
        var lColumnIndex = null,
            lHtml = [],
            lLength = mColumns.length,
            lDataType,
            lColumn = null;
        for (lColumnIndex = 0; lColumnIndex < lLength; lColumnIndex++) {
            lColumn = mColumns[lColumnIndex];
            lHtml.push('<th class="');
            if (mThis.isNothing(lColumn.canResize) || (!mThis.isNothing(lColumn.canResize) && lColumn.canResize)) {
                lHtml.push('sumo-listview-resizable-header ');
            } else {
                lHtml.push('sumo-listview-static-header ');
            }
            lHtml.push('sumo-listview-header-cell"><div title="');
            if (!mThis.isNothing(lColumn.hoverText)) {
                lHtml.push(lColumn.hoverText);
            }
            else {
                if (mLocalization) {
                    lHtml.push(formatRemoveSpan(lColumn.title));
                }
                //else {
                //    lHtml.push(lColumn.title);
                //}
            }
            lHtml.push('" id="');
            lHtml.push(mThis.Id);
            lHtml.push(lColumn.id);
            lHtml.push('" class="');
            if (mThis.isNothing(lColumn.canResize) || (!mThis.isNothing(lColumn.canResize) && lColumn.canResize)) {
                lHtml.push('sumo-listview-resizable-div ');
            }
            // cell class = listviewId + columnId + -header
            lHtml.push(mThis.Id);
            lHtml.push(lColumn.id);
            lHtml.push('-header"><div style="overflow: hidden; text-overflow: ellipsis; -o-text-overflow: ellipsis;">');
            if (lColumn.sortable) {
                lDataType = 'undefined';
                if(!mThis.isNothing(lColumn.dataType)){
                    lDataType = lColumn.dataType.toLowerCase();
                }
                lHtml.push('<div class="sumo-header-sort sumo-data-');
                lHtml.push(lDataType);
                lHtml.push('" id="');
                lHtml.push(mThis.Id);
                lHtml.push(lColumn.dataField);
                lHtml.push('"></div>');
            }
            if (!mThis.isNothing(lColumn.title) && lColumn.title.replace(' ', '') !== '') {
                lHtml.push(lColumn.title);
            } else {
                lHtml.push('&nbsp;');
            }

            lHtml.push('</div></div></th>');
        }
        return lHtml.join('');
    }




    function getBodyContent() {
        var lColumnIndex = null,
            lHtml = [],
            lLength = mColumns.length,
            lValue = '',
            lColumn = null,
            lRowKey = null,
            lRowIndex = 0,
            lRow = null;

        mViewIndex = [];
        mDataIndex = {};
        for (lRowKey in mDataSource) {
            if (mDataSource.hasOwnProperty(lRowKey)) {
                lRow = mDataSource[lRowKey];
                if (mThis.isNothing(lRow)) {
                    continue;
                    //throw (mThis.className() + '.Id: ' + mThis.Id + '. Error binding data. Item with hash index of ' + lRowKey.toString() + ' does not exist.');
                }
                lHtml.push('<tr class="sumo-data-row" id="');
                lHtml.push(mThis.Id);
                lHtml.push('Row');
                if (mKeyField !== null) {
                    mViewIndex.push(lRow[mKeyField]);
                    mDataIndex[lRow[mKeyField]] = lRowKey;
                    lHtml.push(lRow[mKeyField]);
                } else {
                    mViewIndex.push(lRowKey);
                    mDataIndex[lRowKey] = lRowKey;
                    lHtml.push(lRowKey);
                }
                lHtml.push('" itemkey="');
                lHtml.push(lRowIndex.toString());
                lHtml.push('">');
                for (lColumnIndex = 0; lColumnIndex < lLength; lColumnIndex++) {
                    lColumn = mColumns[lColumnIndex];

                    if (mThis.isNothing(lColumn.html)) {
                        if (mThis.isNothing(lColumn.formatMethod)) {
                            lValue = lRow[lColumn.dataField];
                        } else {
                            if (lColumn.id === "EventIcon" && lRow['Description'] === "Enrollink Missed Location Verification") {
                                lValue = '<span/>'
                            } else {
                                lValue = lColumn.formatMethod(lRow[lColumn.dataField],lRow);
                            }
                        }
                    } else {
                        lValue = lColumn.html;
                    }

                    // cell id = listviewId + columnId + Row + rowIndex
                    lHtml.push('<td class="sumo-listview-data-cell" id="');
                    lHtml.push(mThis.Id);
                    lHtml.push('Row');
                    lHtml.push(lRowIndex.toString());
                    lHtml.push('Column');
                    lHtml.push(lColumn.id);
                    lHtml.push('"><div style="overflow: hidden; text-overflow: ellipsis; -o-text-overflow: ellipsis;" class="sumo-listview-data-cell ');
                    // cell class = listviewId + columnId + -data
                    lHtml.push(mThis.Id);
                    lHtml.push(lColumn.id);
                    lHtml.push('-data ');
                    lHtml.push(lColumn.cssClass);
                    //lHtml.push(' ');
                    lHtml.push('">');
                    lHtml.push(lValue);
                    lHtml.push('</div></td>');
                }
                lHtml.push('</tr>');
                ++lRowIndex;
            }
        }
        // if no data, then add empty row
        if (lRowIndex === 0) {
            lHtml.push('<tr class="sumo-listview-nodata-row"><td class="sumo-listview-nodata-cell" colspan="' + mColumns.length + '">' + localizeWrapper('cNoData') + '</td></tr>');
        }
        return lHtml.join('');
    }

    function repositionHeader() {
        if (!mThis.isNothing(mBody) && !mThis.isNothing(mBody.offset()) && !mThis.isNothing(mBody.offset().left) && !mThis.isNothing(mThis.ControlElement) && !mThis.isNothing(mThis.ControlElement.offset()) && !mThis.isNothing(mThis.ControlElement.offset().left)) {
            mHeader.css('left', (mBody.offset().left - mThis.ControlElement.offset().left).toString() + 'px');
        }
    }

    function viewport_OnScroll() {
        repositionHeader();
    }

    function selectRow(aKey) {
        mBody.find('#' + mThis.Id + 'Row' + aKey).addClass('sumo-data-row-selected');
    }

    function unselectRow(aKey) {
        mBody.find('#' + mThis.Id + 'Row' + aKey).removeClass('sumo-data-row-selected');
    }

    function disableRows(aList) {
        var lKey;
        for (lKey in aList) {
            if (aList.hasOwnProperty(lKey)) {
                mBody.find('#' + mThis.Id + 'Row' + aList[lKey]).removeClass('sumo-data-row-selected');
                mBody.find('#' + mThis.Id + 'Row' + aList[lKey]).addClass('sumo-data-row-disabled');
            }
        }
    }

    function removeDisabledRowAttribute(aKey) {
        if(isNullOrUndefined(aKey)){
            mBody.find('.sumo-data-row-disabled').removeClass('sumo-data-row-disabled');
        }
        //mBody.find('#' + mThis.Id + 'Row' + aKey).removeClass('sumo-data-row-disabled');
    }
    this.getSelectedKey = function() {
        return selectedKey;
    }

    this.getDeSelectedKey = function() {
        return deselectedKey;
    }
    
    this.selectChosen = function (aList) {
        var lKey;
        for (lKey in aList) {
            if (aList.hasOwnProperty(lKey)) {
                selectRow(aList[lKey]);
                if(!findDuplicates(mSelectedKey, aList[lKey]))
                    mSelectedKey.push(aList[lKey]);
            }
        }
    }

    this.unSelect = function (aList) {
        var lKey,
            lIndex = null;

        for (lKey in aList) {
            if (aList.hasOwnProperty(lKey)) {
                unselectRow(aList[lKey]);
                if (!isNullOrUndefined(mSelectedKey.indexOf(aList[lKey]))) {
                    lIndex = mSelectedKey.indexOf(aList[lKey]);
                    mSelectedKey.splice(lIndex, 1);
                }
            }
        }
    }

    this.disable = function(aList) {
        disableRows(aList);
    }

    this.removeDisabled = function(aKey) {
        removeDisabledRowAttribute(aKey);
    }

    function findDuplicates(aList,aValue) {
        var lData = aList.indexOf(aValue);
        if (aList[lData] == aValue) {
            return true;
        }
        else {
            return false;
        }
    }

    function multiSelect(aKey) {
        var lIndex = null;

        if ((mSelectedKey === null) || (mSelectedKey.constructor !== Array)) {
            mSelectedKey = [];
        }
        // don't allow select if the item is not in the list
        if (mViewIndex.indexOf(aKey) !== -1) {
            lIndex = mSelectedKey.indexOf(aKey);
            if (lIndex === -1) {
                deselectedKey = null;
                selectedKey = aKey;
                selectRow(aKey);
                mSelectedKey.push(aKey);
            } else {
                if (mSelectedKey.length > 1 || mCanUnselect) {
                    deselectedKey = aKey;
                    unselectRow(aKey);
                    mSelectedKey.splice(lIndex, 1);
                }
            }
        }
    }

    function unselectAll() {
        if (!isNullOrUndefined(mBody)) {
            mBody.find('.sumo-data-row-selected').removeClass('sumo-data-row-selected');
        }
        mSelectedKey = null;
    }

    function selectList(aKeyList) {
        var lIndex = null,
            lLength = aKeyList.length;

        unselectAll();
        mSelectedKey = [];

        lLength = aKeyList.length;
        for (lIndex = 0; lIndex < lLength; lIndex++) {
            multiSelect(aKeyList[lIndex]);
        }
    }

    function selectSingle(aKey) {
        var lItems = null;

        if (mCanUnselect && aKey === mSelectedKey) {
            unselectRow(mSelectedKey);
            mSelectedKey = null;
        } else if (!mCanUnselect && aKey === mSelectedKey && mViewIndex.indexOf(mSelectedKey) === -1) {
            // if can't unselected and the keys match and the selected key is no longer in the data source
            // then set the selection to the first item in the list
            if (mViewIndex.length > 0) {
                mThis.selectedIndex(0);
            } else {
                mSelectedKey = null;
            }
        } else {
            // don't allow select if the item is not in the list
            if (mViewIndex.indexOf(aKey) !== -1 || mViewIndex.indexOf(aKey.toString()) !== -1) {
                unselectRow(mSelectedKey);
                selectRow(aKey);

                lItems = mViewPort.find('#' + mThis.Id + 'Row' + aKey + '.sumo-data-row-selected');
                if (lItems.length > 0 && mScrollIntoView == true) {
                    lItems[0].scrollIntoView(false);
                }

                mSelectedKey = aKey;
            }
        }
    }

    function select(aKey, aCtrlKey) {
        if (!mThis.isNothing(aKey)) {
            mThis.trigger('selectedchanging', { 'Current': mSelectedKey, 'New': aKey });
            if ((aKey.constructor === Array) && (mSelectMethod === 'auto' || mSelectMethod === 'ctrlKey')) {
                selectList(aKey);
            } else if (mSelectMethod === 'single') {
                if (aKey.constructor === Array) {
                    throw (mThis.className() + '.Id: ' + mThis.Id + '. Invalid argument. Cannot pass Array to select() with selectMethod of single.');
                }
                selectSingle(aKey);
            } else if (mSelectMethod === 'auto' || (mSelectMethod === 'ctrlKey' && aCtrlKey === true)) {
                multiSelect(aKey);
            } else if (mSelectMethod === 'ctrlKey' && aCtrlKey === false) {
                unselectAll();
                multiSelect(aKey);
            }
            mThis.trigger('selectedchanged', mSelectedKey);
        }
    }


    this.selectAllList = function () {
        select(mViewIndex, true);
    }

    this.unselectAllList = function () {
        unselectAll();
    }

    this.selectedIndex = function (aSelectedIndex) {
        var lResult = null,
            lKey;
        if (this.isNothing(aSelectedIndex)) {
            lResult = mViewIndex.indexOf(mSelectedKey);
        } else {
            lKey = mViewIndex[aSelectedIndex];
            if (!this.isNothing(lKey)) {
                this.selected(lKey);
            }
        }
        return lResult;
    };

    this.selected = function (aSelectedKey, aAddItem) {
        var lResult = null,
            lAddItem = false;
        if (this.isNothing(aSelectedKey)) {
            lResult = mSelectedKey;
        } else {
            if (!this.isNothing(aAddItem)) {
                lAddItem = aAddItem;
            }
            select(aSelectedKey, lAddItem);
        }
        return lResult;
    };

    this.selectedDataItem = function () {
        var lResult = null,
            i;
        if (!mThis.isNothing(mSelectedKey)) {
            if (mSelectedKey.constructor !== Array) {
                lResult = mDataSource[mDataIndex[mSelectedKey]];
            } else {
                lResult = [];
                for (i = 0; i < mSelectedKey.length; i++) {
                    lResult.push(mDataSource[mDataIndex[mSelectedKey[i]]]);
                }
            }
        }
        return lResult;
    };

    // custom sort function for list view
    this.SortUp = function (aSelected) {
        mDataSource[aSelected].SortOrder = aSelected - 1;
        mDataSource[aSelected - 1].SortOrder = aSelected;
        return SwapRows(aSelected, aSelected - 1);
    }

    this.SortDown = function (aSelected) {
        mDataSource[aSelected].SortOrder = aSelected + 1;
        mDataSource[aSelected + 1].SortOrder = aSelected;
        return SwapRows(aSelected, aSelected + 1);
    }

    function SwapRows(aRowA, aRowB) {
        var lTemp;

        lTemp = mDataSource[aRowA];
        mDataSource[aRowA] = mDataSource[aRowB];
        mDataSource[aRowB] = lTemp;

        // has been sorted
        mIsSorted = true;

        return mDataSource;
    }

    this.IsSorted = function () {
        return mIsSorted;
    }
    function row_OnClick(aEvent) {
        // "this" refers to the object raising the event
        var lRow = $(this),
            lRowIndex = lRow.attr('itemkey'),
            lSelectedKey = mViewIndex[parseInt(lRowIndex, 10)];
        aEvent.stopImmediatePropagation();
        select(lSelectedKey, aEvent.ctrlKey);
    }

    function column_OnResized(event, ui) {
        // could save to user settings
        mThis.trigger('columnresize', ui.element);
    }

    function column_OnResizing(event, ui) {
        $('div.' + ui.element[0].id + '-data').width(ui.element.width());
    }

    function resizeColumns() {
        var lColumnIndex = null,
            lColumn = null,
            lLength = mColumns.length,
            lWidth = 10;
        for (lColumnIndex = 0; lColumnIndex < lLength; lColumnIndex++) {
            lColumn = mColumns[lColumnIndex];
            lWidth = lColumn.width;
            // default to autoData
            if (mThis.isNothing(lWidth) || lWidth === '') {
                lWidth = 'autoData';
            }
            switch (lWidth) {
                case 'autoHeader':
                    lWidth = $('div.' + mThis.Id + lColumn.id + '-header').width();
                    if (!mThis.isNothing(lColumn.minWidth) && (lWidth < lColumn.minWidth)) {
                        lWidth = lColumn.minWidth;
                        $('div.' + mThis.Id + lColumn.id + '-header').width(lWidth);
                    }
                    if (!mThis.isNothing(lColumn.maxWidth) && (lWidth > lColumn.maxWidth)) {
                        lWidth = lColumn.maxWidth;
                        $('div.' + mThis.Id + lColumn.id + '-header').width(lWidth);
                    }
                    $('div.' + mThis.Id + lColumn.id + '-data').width(lWidth);
                    break;
                case 'autoData':
                    lWidth = $('div.' + mThis.Id + lColumn.id + '-data').width();
                    if (!mThis.isNothing(lColumn.minWidth) && (lWidth < lColumn.minWidth)) {
                        lWidth = lColumn.minWidth;
                        $('div.' + mThis.Id + lColumn.id + '-data').width(lWidth);
                    }
                    if (!mThis.isNothing(lColumn.maxWidth) && (lWidth > lColumn.maxWidth)) {
                        lWidth = lColumn.maxWidth;
                        $('div.' + mThis.Id + lColumn.id + '-data').width(lWidth);
                    }
                    $('div.' + mThis.Id + lColumn.id + '-header').width(lWidth);
                    break;
                default:
                    $('div.' + mThis.Id + lColumn.id + '-data').width(lWidth);
                    $('div.' + mThis.Id + lColumn.id + '-header').width(lWidth);
            }
        }
    }

    this.resizeColumns = function () {
        resizeColumns();
    };


    function resizeViewPort() {
        var lHeight = mThis.ControlElement.innerHeight();
        if (mViewPort !== null) {
            lHeight = lHeight - mHeader.height();
            if (mUpdatedRow.is(":visible")) {
                lHeight = lHeight - mUpdatedRow.height();
            }
            mThis.ControlElement.height(mThis.ParentElement.innerHeight());
            mViewPort.height(lHeight);

        }
    }

    this.resize = function () {
        resizeViewPort();
    };

    this.setUpdated = function (aIsUpdated) {
        if (!mThis.isNothing(mUpdatedRow)) {
            if (aIsUpdated) {
                mUpdatedRow.show();
            } else {
                mUpdatedRow.hide();
            }
        }
        resizeViewPort();
        resizeColumns();
    };

    this.setUpdateNotice = function (aIsUpdated, aString) {
        if (mUpdateNotice[0]) {
            var lNoticeId = mUpdateNotice[0].id;
            if (!mThis.isNothing(mUpdateNotice)) {
                if (aIsUpdated) {
                    mUpdateNotice.show();
                    $('#' + lNoticeId + ' .sumo-listview-data-update-notice').html(aString);
                } else {
                    mUpdateNotice.hide();
                }
            }
            resizeViewPort();
            resizeColumns();
        }
    }

    function mUpdatedRow_OnClick() {
        mThis.trigger('update', null);
    }
    function mUpdateNotice_OnClick() {
        mThis.trigger('updatenotice', null);
    }



    function displaySortButtonImage() {
        "use strict";
        var lColumnId = '',
            lDirection = 'ascending';

        if (!mThis.isNothing(mSortedColumn)) {
            lColumnId = mThis.Id + mSortedColumn.ColumnName;
            if (!mThis.isNothing(mSortedColumn.SortDirection)) {
                lDirection = mSortedColumn.SortDirection.toLowerCase();
            }
            if ($('#' + mThis.Id + mSortedColumn.ColumnName).hasClass('sumo-data-number')) {
                if (lDirection === 'ascending') {
                    lDirection = 'descending';
                } else {
                    lDirection = 'ascending';
                }
            }
        }
        mThis.ControlElement.find('.sumo-header-sort').removeClass('sumo-header-sort-ascending').removeClass('sumo-header-sort-descending');
        mThis.ControlElement.find('#' + lColumnId).addClass('sumo-header-sort-' + lDirection);        
    }



    function generateSortExpression() {
        var lSort = new SortExpression(),
            lColumnId = mSortedColumn.ColumnName;

        if (!mThis.isNothing(lColumnId)) {
            lColumnId = lColumnId.split(mThis.Id);
            if (mSortedColumn.SortDirection.toLowerCase() === 'ascending') {
                lSort.addAscendingColumn(lColumnId[(lColumnId.length - 1)]);
            } else {
                lSort.addDescendingColumn(lColumnId[(lColumnId.length - 1)]);
            }
        }
        return lSort;
    }

    this.sortExpression = function (aSortExpression) {

        if (mThis.isNothing(aSortExpression)) {
            return generateSortExpression();
        } else {
            //set values from sort expression
            mSortedColumn.ColumnName = aSortExpression.Columns[0].ColumnName;
            mSortedColumn.SortDirection = aSortExpression.Columns[0].Direction.toLowerCase();
            mThis.trigger('sort', generateSortExpression());
        }
    };

    this.sort = function () {
        mThis.trigger('sort', generateSortExpression());
    };



    function mSortListViewButton_OnClick(aColumn) {
        var lColumnId = aColumn[0].id,
            lColumnNameSplit = lColumnId.split(mThis.Id),
            lColumnName = lColumnNameSplit[(lColumnNameSplit.length - 1)];
        if (mSortedColumn.ColumnName === lColumnName && mSortedColumn.SortDirection === 'ascending') {
            mSortedColumn.SortDirection = 'descending';
        } else {
            mSortedColumn.SortDirection = 'ascending';
        }
        mSortedColumn.ColumnName = lColumnName;

        mThis.trigger('sort', generateSortExpression());
    }





    function dataBind() {
        var lHtml = [];

        if (mThis.isNothing(mColumns)) {
            throw ('sumo.controls.ListView: aColumns parameter is required.');
        }

        if (mIsDirty && !mThis.isNothing(mDataSource)) {
            lHtml.push('<div id="');
            lHtml.push(mThis.Id);
            lHtml.push('Updated" class="sumo-listview-updated"><div class="sumo-listview-datarefresh">' + localizeText('cUpdateAvailable') + '</div>');
            lHtml.push('</div>');

            lHtml.push('<div id="');
            lHtml.push(mThis.Id);
            lHtml.push('UpdateNotice" class="sumo-listview-update-notice"><div class="sumo-listview-data-update-notice" style="font-weight: 700;">  </div>');
            lHtml.push('</div>');

            lHtml.push('<div class="sumo-listview-header"><table class="sumo-listview-header-table" id="');
            lHtml.push(mThis.Id);
            lHtml.push('Header" style="position: relative;" cellspacing="0" cellpadding="0">');
            lHtml.push('<thead>');
            lHtml.push('<tr class="sumo-listview-header-row">');
            lHtml.push(getHeaderContent());
            lHtml.push('</tr>');

            lHtml.push('</thead>');
            lHtml.push('</table></div>');
            lHtml.push('<div id="');
            lHtml.push(mThis.Id);
            lHtml.push('ViewPort" class="sumo-listview-viewport" style="height: 0px; overflow: auto;">');
            lHtml.push('<table id="');
            lHtml.push(mThis.Id);
            lHtml.push('Table" class="sumo-listview-data-table" cellspacing="0" cellpadding="0"><tbody id="');
            lHtml.push(mThis.Id);
            lHtml.push('Body">');
            lHtml.push(getBodyContent());
            lHtml.push('</tbody></table>');
            // lHtml.push('<table class="sumo-listview-footer" id="' + mThis.Id + 'Footer" style="position: relative;" cellspacing="0" cellpadding="0">');
            lHtml.push('</div>');

            mThis.ControlElement.html(lHtml.join(''));

            mViewPort = mThis.ControlElement.find('#' + mThis.Id + 'ViewPort');
            mHeader = mThis.ControlElement.find('#' + mThis.Id + 'Header');
            mTable = mThis.ControlElement.find('#' + mThis.Id + 'Table');
            mBody = mThis.ControlElement.find('#' + mThis.Id + 'Body');
            mRows = mThis.ControlElement.find('#' + mThis.Id + 'Body tr');
            mUpdatedRow = mThis.ControlElement.find('#' + mThis.Id + 'Updated');
            mUpdateNotice = mThis.ControlElement.find('#' + mThis.Id + 'UpdateNotice');
            mSortableColumn = mThis.ControlElement.find('.sumo-header-sort');
            mRows.click(row_OnClick);
            mUpdatedRow.click(mUpdatedRow_OnClick);
            mUpdateNotice.click(mUpdateNotice_OnClick);
            mSortableColumn.click(function (aEvent) {
                mSortListViewButton_OnClick($(aEvent.target));

            });

            mTable.find('.StopClickBubble').click(function (aEvent) {
                aEvent.stopPropagation();
            });

            mRows.find('div').children().resize(function () {
                resizeColumns();
            });

            if (!mShowHeader) {
                mHeader.hide();
            }

            mViewPort.scroll(viewport_OnScroll);
            mRows.click(row_OnClick);
            if (mSelectMethod !== 'none') {
                mRows.addClass('sumo-selectable');
            }

            mBody.find('tr:odd').addClass('sumo-data-row-odd');
            mBody.find('tr:even').addClass('sumo-data-row-even');
            //            if (mOddRowClass !== null) {
            //                mBody.find('tr:odd').addClass(mOddRowClass)
            //                                    .addClass('sumo-data-row-odd');
            //            }
            //            if (mEvenRowClass !== null) {
            //                mBody.find('tr:even').addClass(mEvenRowClass)
            //                                     .addClass('sumo-data-row-even');
            //            }

            $('#' + mThis.Id + ' div.sumo-listview-resizable-div').resizable({
                'alsoResize': '',
                'resize': column_OnResizing,
                'stop': column_OnResized,
                'minWidth': 40,
                'handles': 'e'
            });

            if (!mThis.isNothing(mSelectedKey)) {
                select(mSelectedKey, false);
            }


            mThis.setUpdated(false);
            mThis.setUpdateNotice(false);

            mIsDirty = false;

            displaySortButtonImage();
            mThis.trigger('databind');
        }
    }

    this.setDataSource = function (aDataSource) {
        mDataSource = aDataSource;
        mIsDirty = true;
        if (!this.isNothing(mDataSource)) {
            dataBind();
        }

        veritracks.localization.localize('#' + mThis.Id);
    };

    this.getDataSource = function () {
        return mDataSource;
    };

    this.getCleanDataSource = function () {
        var newDataSource = [],
            lKey;
        for (lKey in mDataSource) {
            if (mDataSource.hasOwnProperty(lKey)) {
                newDataSource.push(mDataSource[lKey].Id);
            }
        }

        return newDataSource;
    }

    this.setColumns = function (aColumns) {
        mThis.trigger('columnschanging');
        mColumns = aColumns;
        mIsDirty = true;
        if (!this.isNothing(mDataSource)) {
            dataBind();
        }
        mThis.trigger('columnschanged');
        veritracks.localization.localize('.sumo-listview-header-row');
    };

    this.getColumns = function () {
        return mColumns;
    };

    this.show = function () {
        if (mIsDirty) {
            dataBind();
        }
        sumo.controls.ListView.prototype.show.call(this);
    };

    function window_OnResize(e) {
        resizeViewPort();
    }

    this.dispose = function () {
        $(window).unbind('resize', window_OnResize);
        if (!mThis.isNothing(mViewPort)) {
            mViewPort.unbind('scroll', viewport_OnScroll);
        }
        if (!mThis.isNothing(mRows)) {
            mRows.unbind('click', row_OnClick);
        }
        $('#' + mThis.Id + ' div.sumo-listview-resizable-div').resizable('destroy');

        mSelectedKey = null;
        mViewIndex = null;
        mDataIndex = null;
        mDataSource = null;
        mIsDirty = false;
        mColumns = null;
        mKeyField = null;
        mCssClass = null;
        mViewPort = null;
        mHeader = null;
        mTable = null;
        mRows = null;
        mBody = null;

        mThis = null;

        sumo.controls.ListView.prototype.dispose.call(this);
    };

    this.render = function () {
        if (!this.isNothing(mCssClass)) {
            this.ControlElement.addClass(mCssClass);
        }
        $(window).resize(window_OnResize);
        this.trigger('render');
    };

    this.render();
};
sumo.controls.ListView.prototype = new sumo.controls.ControlBase();
sumo.controls.ListView.prototype.constructor = sumo.controls.ListView;
sumo.controls.ListView.prototype.baseClass = sumo.controls.ControlBase;